import { WhichWeightAPI } from 'WhichWeightAPI'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { default_equipment_profile } from 'functions/equipmentUtils'

import BrandColorButton from 'components/Buttons/BrandColorButton'
import ContentFrame from 'components/Frame/ContentFrame'
import EquipmentProfilePreviewCard from 'components/EquipmentProfile/EquipmentProfilePreviewCard'

export default function EquipmentProfileListComponent({
    NavigationAction = () => { console.log('Add a navigation action') }
}) {
    
    const profileType = useSelector(state => state.athleteProfile.profileType)
    const groupId = useSelector(state => state.athleteProfile.groupId)
    const athleteId = useSelector((state) => state.athleteProfile.userId)
    
    const [equipmentProfiles, setEquipmentProfiles] = useState(null)
    const [activeEquipmentProfile, setActiveEquipmentProfile] = useState(null)
    const [inactiveEquipmentProfiles, setInactiveEquipmentProfiles] = useState(null)

    const FetchEquipmentProfilesFromBackend = async () => {

        if (profileType === 'group') {
            const jsonBody = { 
                groupId: groupId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'GET', '/group_equipment_profiles', jsonBody)

            // console.log(result)

            setEquipmentProfiles(result.data.data)

            setActiveEquipmentProfile(result.data.data.find(profile => profile.active === 1))

            setInactiveEquipmentProfiles(result.data.data.filter(profile => profile.active === 0))
        }

        if (profileType === 'individual') {
            const jsonBody = { 
                userId: athleteId
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'GET', '/equipment_profiles', jsonBody)

            // console.log(result)

            setEquipmentProfiles(result.data.data)

            setActiveEquipmentProfile(result.data.data.find(profile => profile.active === 1))

            setInactiveEquipmentProfiles(result.data.data.filter(profile => profile.active === 0))
        }
        
    }

    const OnEquipmentProfileSelected = (equipmentProfile) => {
        const navigationProps = {
            state: {
                modificationKey: 'edit',
                propEquipmentProfile: JSON.parse(JSON.stringify(equipmentProfile))
            }
        }

        NavigationAction('/equipmentProfile/modify', navigationProps)
    }

    const OnCreateEquipmentProfile = () => {
        const navigationProps = {
            state: {
                modificationKey: 'create',
                propEquipmentProfile: {
                    name: '',
                    description: '',
                    equipmentProfileJSON: JSON.stringify(default_equipment_profile)
                }
            }
        }

        NavigationAction('/equipmentProfile/modify', navigationProps)
    }

    useEffect(() => { FetchEquipmentProfilesFromBackend() }, [])

    if (equipmentProfiles === null) {
        return (
            <div className='w-full h-80 bg-gray-200 rounded-lg animate-pulse' />
        )
    }
    
    return (
        <>
            <div className="flex items-center">
                <div className="flex-1">Active Equipment Profile</div>

                <div className="w-40">
                    <BrandColorButton
                        size='extra-small'
                        text="Create"
                        action={() => OnCreateEquipmentProfile()}
                        className="shadow-md"
                    />
                </div>
            </div>

            {equipmentProfiles !== null && equipmentProfiles.length === 0 && (
                <ContentFrame>
                    <div className='text-center text-gray-500 py-4'>No equipment profiles found</div>
                </ContentFrame>
            )}

            {activeEquipmentProfile &&
                <div className='grid grid-cols-3 gap-4'>
                    <EquipmentProfilePreviewCard 
                        equipmentProfile={activeEquipmentProfile} 
                        OnEquipmentProfileSelected={OnEquipmentProfileSelected} 
                    />
                </div>
            }

            {inactiveEquipmentProfiles !== null && inactiveEquipmentProfiles.length > 0 && (
                <>
                    <p>Other Profiles</p>

                    <div className='grid grid-cols-3 gap-4'>
                        {inactiveEquipmentProfiles.map((equipmentProfile, index) => (
                            <div key={index}>
                                <EquipmentProfilePreviewCard
                                    equipmentProfile={equipmentProfile} 
                                    OnEquipmentProfileSelected={OnEquipmentProfileSelected} 
                                />
                            </div>
                        ))}
                    </div>
                </>
            )}
        </>
    )
}